module.exports = __webpack_public_path__ + "img/200113.ecb445a1.png";